import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBank(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.25 9.25v8m-4 0v-8m-10.5 0v8m4 0v-8m9.574 8H5.676c-1.15 0-2.171.736-2.535 1.828a.89.89 0 0 0 .845 1.172h16.028a.89.89 0 0 0 .845-1.172 2.67 2.67 0 0 0-2.535-1.828m1.64-8H4.036a1.286 1.286 0 0 1-.58-2.433l7.191-3.633a3 3 0 0 1 2.706 0l7.19 3.633a1.286 1.286 0 0 1-.579 2.433"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBank);
export default ForwardRef;
